import { Box, Container, Flex, Grid, GridItem } from '@chakra-ui/react';

import MyImage from '@components/MyImage';
import { configEnv } from '@libraries/config';
import { memo } from 'react';
import { Form, Slider } from './Partials';

const Login: React.FC = (): JSX.Element => {
  return (
    <Container pos="relative" maxW="container.lg">
      <Flex minH="100vh" align="center">
        <Grid
          templateColumns={{
            base: '1fr',
            lg: '480px 1fr',
          }}
          alignItems="center"
          bg="whiteAlpha.900"
          backdropFilter="blur(10px)"
          rounded={{
            base: '0',
            md: 'xl',
          }}
          border="1px solid rgba(255, 255, 255, 0.2)"
          shadow={{
            base: 'none',
            md: '0 0 15px 1px rgba(0,0,0,0.05)',
          }}
          overflow="hidden"
          w="full"
        >
          <GridItem
            display={{
              base: 'none',
              lg: 'block',
            }}
            pos="relative"
          >
            <Box
              display={{
                base: 'none',
                md: 'block',
              }}
              pos="absolute"
              top="40px"
              left="40px"
              zIndex="999"
            >
              <MyImage
                src={`${configEnv.assetUrl}/logo-white.png`}
                alt={configEnv.appName}
                w="100px"
                objectFit="contain"
                loading="lazy"
              />
            </Box>
            <Slider />
          </GridItem>
          <GridItem
            p={{
              base: '1',
              md: '8',
            }}
            pos="relative"
          >
            <Box
              pos="absolute"
              top="-50px"
              right="-25px"
              opacity=".4"
              pointerEvents="none"
            >
              <MyImage
                src={`${configEnv.assetUrl}/img/dots.svg`}
                alt={configEnv.appName}
                w="100px"
                objectFit="contain"
                loading="lazy"
              />
            </Box>
            <Form />
          </GridItem>
        </Grid>
      </Flex>
    </Container>
  );
};

export default memo(Login);
